// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settingsPopover_root__3msYF {\n  padding: 5px 10px;\n  box-sizing: border-box; }\n  .settingsPopover_root__3msYF .settingsPopover_popoverItem__X59Fn {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    box-sizing: border-box;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    color: #464646;\n    cursor: pointer;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.116);\n    display: flex;\n    align-items: center; }\n    .settingsPopover_root__3msYF .settingsPopover_popoverItem__X59Fn .settingsPopover_icon__2Q-bl {\n      margin-right: 10px;\n      color: #464646;\n      font-size: 16px; }\n", ""]);
// Exports
exports.locals = {
	"root": "settingsPopover_root__3msYF",
	"popoverItem": "settingsPopover_popoverItem__X59Fn",
	"icon": "settingsPopover_icon__2Q-bl"
};
module.exports = exports;
